import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, ReadonlyHttpApiCollectionRepository } from '@softline/core';
import { SALES_STATISTICS_DOCUMENT_TYPES } from '../sales-statistics.api';
import { DocumentType } from '../types/document-type';

@Injectable()
export class DocumentTypesRepository extends ReadonlyHttpApiCollectionRepository<
  DocumentType[]
> {
  constructor() {
    super(inject(ApiDataAccess), SALES_STATISTICS_DOCUMENT_TYPES);
  }
}
